// extracted by mini-css-extract-plugin
export default {"overlay":"overlay-loading_overlay__LM0ex","loading":"overlay-loading_loading__mImVt"};